import { render } from "./MoviesList.vue?vue&type=template&id=4b6d2592"
import script from "./MoviesList.vue?vue&type=script&lang=js"
export * from "./MoviesList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__